import './Background.css';

export const Background = () => {
	return (
		<div className="background" />
	)
}